import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface DeleteConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteConfirmDialog({
  open,
  onClose,
  onConfirm,
}: DeleteConfirmDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('chatConfig.dialog.deleteTitle')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('chatConfig.dialog.deleteMessage')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('chatConfig.dialog.cancel')}</Button>
        <Button onClick={onConfirm} color="error">
          {t('chatConfig.dialog.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}